module.exports = __webpack_public_path__ + "static/media/mapLink.c2c13297.svg";